module.exports = __webpack_public_path__ + "img/wheel_LOW_win.8f9c21b4.png";